import IconCopy from "app/components/shared/app/icons/IconCopy";
import { copyToClipboard, getAccountTimezone } from "app/lib/utils/adaya/AdayaUtils";
import { formatIsoShort, todayStart } from "app/lib/utils/DateUtils";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import ContentPanel from "../shared/ContentPanel";

const UserDetails = ({ accounts, activeAccount, _id, ...props }) => {

    const timezone = getAccountTimezone(activeAccount);

    console.log(`acc`, activeAccount);

    return (
        <div className={`active-account-info ${_id && "edit-user-detail-modal"}`}>
            <ContentPanel dividerOrientation="left" title="Active Account Info">
                <table className="script-result-details-table" border={1}>
                    <tr>
                        <td className="td-bold">Account Name</td>
                        <td>{activeAccount?.name ? <div className="td-display-flex"><div>{activeAccount?.name}</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(activeAccount?.name)} /></div> : "-"}</td>
                        <td className="td-bold">Account Id</td>
                        <td>{activeAccount?._id ? <div className="td-display-flex"><div>{activeAccount?._id}</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(activeAccount?._id)} /></div> : ""}</td>
                    </tr>
                    <tr>
                        <td className="td-bold">Last Login</td>
                        <td>{activeAccount?.lastLogin ? moment(activeAccount?.lastLogin).format('M/D/YYYY @ H:M:SS A') : "-"}</td>
                        <td className="td-bold">Tracking Id</td>
                        <td>{activeAccount?.tracking?.trackingId ? <div className="td-display-flex"><div>{activeAccount?.tracking?.trackingId}</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(activeAccount?.tracking?.trackingId)} /></div> : ""}</td>
                    </tr>
                    <tr>
                        <td className="td-bold">Store Timezone and Currency</td>
                        <td>
                            {activeAccount?.storeInfo?.timezone ? <p>{activeAccount?.storeInfo?.timezone}</p> : ""}
                            {activeAccount?.storeInfo?.currency ? <p>{activeAccount?.storeInfo?.currency}</p> : ""}
                        </td>
                        <td className="td-bold">Store Start of Today</td>
                        <td><div className="td-display-flex"><div>{formatIsoShort(todayStart(timezone))} (UTC)</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(todayStart(timezone).toISOString())} /></div></td>
                    </tr>
                    <tr>
                        <td className="td-bold">Account Providers</td>
                        <td>{activeAccount?.providers?.length ? activeAccount?.providers.map(({ name }) => name).join(", ") : "-"}</td>
                        <td className="td-bold">Account Users</td>
                        <td className="td-display-column">
                            {accounts?.length ? accounts.map(({ _id, name }) => <Link to={`/admin/accounts/account/${_id}`}>{name}</Link>) : "-"}
                        </td>
                    </tr>
                </table>
            </ContentPanel>
        </div>
    )
}

export default UserDetails;